import "./fix-chromium-bug";
import("./main.bootstrap").then((m) => m.mount());
